import { createFileRoute } from '@tanstack/react-router';
import { ErrorLayout } from '@amber-ui/core';

export const Route = createFileRoute('/error')({
  component: ErrorLayout,
});
